import { render, staticRenderFns } from "./LoadingBet.vue?vue&type=template&id=40305a68&scoped=true"
import script from "./LoadingBet.vue?vue&type=script&lang=js"
export * from "./LoadingBet.vue?vue&type=script&lang=js"
import style0 from "./LoadingBet.vue?vue&type=style&index=0&id=40305a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40305a68",
  null
  
)

export default component.exports